export default __webpack_public_path__ + "static/media/pant.1fa6d039.jpg";